define('modules/start/products/automation/activity/view',['require','exports','module','views/BaseView','ldsh!./template'],function (require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),
        initialize: function () {
            if (this.productDetails) {
                this.listenTo(this.productDetails, "sync", this.render);
            }
        },
        serialize: function () {
            return {
                productsReport: this.productsReport,
                productDetails: this.productDetails,
                activeScenes: this.productDetails.get('activeScenes'),
                isAdm: this.isAdm
            };
        }
    });

    module.exports = Layout;
});
